var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7558 8.59091H10.7442V12.6477H16.507C15.9698 15.225 13.7233 16.7045 10.7442 16.7045C7.22791 16.7045 4.39535 13.9364 4.39535 10.5C4.39535 7.06364 7.22791 4.29545 10.7442 4.29545C12.2581 4.29545 13.6256 4.82045 14.7 5.67955L17.8256 2.625C15.9209 1.00227 13.4791 0 10.7442 0C4.78605 0 0 4.67727 0 10.5C0 16.3227 4.78605 21 10.7442 21C16.1163 21 21 17.1818 21 10.5C21 9.87955 20.9023 9.21136 20.7558 8.59091Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.976807 16.7045V4.29541L7.32552 10.5L-0.976807 16.7045Z",
    fill: "#FBBC05"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7558 8.59091H10.7442V12.6477H16.507C15.9698 15.225 13.7233 16.7045 10.7442 16.7045C7.22791 16.7045 4.39535 13.9364 4.39535 10.5C4.39535 7.06364 7.22791 4.29545 10.7442 4.29545C12.2581 4.29545 13.6256 4.82045 14.7 5.67955L17.8256 2.625C15.9209 1.00227 13.4791 0 10.7442 0C4.78605 0 0 4.67727 0 10.5C0 16.3227 4.78605 21 10.7442 21C16.1163 21 21 17.1818 21 10.5C21 9.87955 20.9023 9.21136 20.7558 8.59091Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.976807 4.29541L7.32552 10.5L10.7441 7.58859L22.4651 5.72723V-0.95459H-0.976807V4.29541Z",
    fill: "#EA4335"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7558 8.59091H10.7442V12.6477H16.507C15.9698 15.225 13.7233 16.7045 10.7442 16.7045C7.22791 16.7045 4.39535 13.9364 4.39535 10.5C4.39535 7.06364 7.22791 4.29545 10.7442 4.29545C12.2581 4.29545 13.6256 4.82045 14.7 5.67955L17.8256 2.625C15.9209 1.00227 13.4791 0 10.7442 0C4.78605 0 0 4.67727 0 10.5C0 16.3227 4.78605 21 10.7442 21C16.1163 21 21 17.1818 21 10.5C21 9.87955 20.9023 9.21136 20.7558 8.59091Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.976807 16.7045L13.6744 5.72723L17.5325 6.2045L22.4651 -0.95459V21.9545H-0.976807V16.7045Z",
    fill: "#34A853"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7558 8.59091H10.7442V12.6477H16.507C15.9698 15.225 13.7233 16.7045 10.7442 16.7045C7.22791 16.7045 4.39535 13.9364 4.39535 10.5C4.39535 7.06364 7.22791 4.29545 10.7442 4.29545C12.2581 4.29545 13.6256 4.82045 14.7 5.67955L17.8256 2.625C15.9209 1.00227 13.4791 0 10.7442 0C4.78605 0 0 4.67727 0 10.5C0 16.3227 4.78605 21 10.7442 21C16.1163 21 21 17.1818 21 10.5C21 9.87955 20.9023 9.21136 20.7558 8.59091Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4651 21.9545L7.32556 10.5L5.37207 9.06814L22.4651 4.29541V21.9545Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/Google_Logo.e21e0b0c82a1a4cf207ac08b6493adb5.svg";
export { ForwardRef as ReactComponent };